import React, { useEffect, useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../../_metronic/_helpers";

import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";
import {
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
  activeFormatter,
  showConfirmDialog,
  formatDate,
  lockedFormatter,
  showDeleteDialog,
  checkPermision,
  iconError,
} from "../../../utility";
import SVG from "react-inlinesvg";

import { isDateFormat, parseDateString } from "../../../utility";
import moment from "moment";

export const ReportTable = ({
  data,
  page,
  sizePerPage,
  sortField,
  sortOrder,
  onTableChange,
  totalSize,
  loading,
  handleSearch,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        no: index + 1 + pageBefore,
        ...item,
      };
    });
    setTableData(initData)
  }, [data, sizePerPage, page]);

  const [tableData, setTableData] = useState([]);
  const columns = [
    // {
    //   text: "No",
    //   dataField: "no",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    //   style: { minWidth: "150px" },
    // },
    {
      text: "VIN",
      dataField: "VIN",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "VON",
      dataField: "VON",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Master Code",
      dataField: "Master_Code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Vehicle Name",
      dataField: "Vehicle_Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Model Code",
      dataField: "Model_Code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Model Name",
      dataField: "Model_Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Color Code",
      dataField: "Color_Code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Color Name",
      dataField: "Color_Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Engine No",
      dataField: "Engine_No",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Mileage",
      dataField: "Mileage",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Key No.",
      dataField: "Key_No",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },

    {
      text: "RCI Result",
      dataField: "RCI_Result",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },

    {
      text: "RCI Date",
      dataField: "RCI_Date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter : formatDate
    },
    {
      text: "Inspection Point",
      dataField: "Inspection_Point",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Damage Conditions",
      dataField: "Damage_Conditions",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Damage Weight",
      dataField: "Damage_Weight",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Input By",
      dataField: "Input_By",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
  ];

 


  const options = {
    page: page < 0 ? 1 : page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-4"
        bootstrap4
        
        keyField="no"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        sort={{ dataField: sortField, order: sortOrder }}
        hover
        striped
        noDataIndication="No data to display.   Please do searching to display particular vehicle(s)"
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
    </>
  );
};
